import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { ReactComponent as ChevronLeft } from "Assets/icons/chevronLeft.svg";
import DibaImg from 'Assets/Images/diba.png'
const DibaSystem = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;

    const content = {
        fa: {
            description: (
                <>
                    این سامانه برای تسهیل ارتباط تمامی ذینفعان اعم از تولیدکنندگان،
                    عرضه‌کنندگان، کارگزاران و سایر نهادهای مالی با بورس انرژی ایران
                    به منظور حذف مکاتبات سنتی و جایگزینی آن با فرآیندهای سیستمی
                    طراحی شده است تا ارتباطات سازمانی با سرعت، دقت و قابلیت پیگیری
                    بالاتری انجام گیرد. کاربردهای این سامانه شامل عضویت کارگزاران،
                    درج نماد و انتشار اطلاعیه‌های عرضه می‌باشد.
                </>
            ),
        },

        en: {
            description: (
                <>
                    This system has been designed to facilitate communication among
                    all stakeholders, including producers, suppliers, brokers, and
                    other financial institutions, with the Iran Energy Exchange by
                    eliminating traditional correspondence and replacing it with
                    system-based processes. As a result, organizational communications
                    are carried out with greater speed, accuracy, and traceability.
                    The applications of this system include broker membership,
                    symbol registration, and publication of supply announcements.
                </>
            ),
        },

        ar: {
            description: (
                <>
                    تم تصميم هذا النظام لتسهيل التواصل بين جميع أصحاب المصلحة،
                    بما في ذلك المنتجين والمورّدين والوسطاء وسائر المؤسسات المالية،
                    مع بورصة الطاقة الإيرانية، بهدف الاستغناء عن المراسلات التقليدية
                    واستبدالها بعمليات قائمة على الأنظمة الإلكترونية، مما يضمن
                    سرعة ودقة وقابلية تتبع أعلى في الاتصالات المؤسسية. وتشمل
                    استخدامات هذا النظام عضوية الوسطاء، إدراج الرموز، ونشر
                    إعلانات العرض.
                </>
            ),
        },
    };


    const { description } = content[currentLang] || content.fa; // fallback to fa

    return (
        <div className="megaMenuContent">
            <div className="row justify-content-between h-100 DibaBg">
                <div className="col-7">
                    <p className="text-justify">{description}</p>
                </div>
                <div className="col-12 d-flex align-items-end">
                    <a href="https://diba.iee.ir" target="_blank" className="btn rounded-5 bg-primary text-white d-inline-flex justify-content-center align-items-center gap-1" >
                        {t("loginToSystem")}
                        <span className="btn p-0 btn-read-more rounded-circle bg-white text-blue d-flex justify-content-center align-items-center">
                            <ChevronLeft width={15} height={10} />
                        </span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default DibaSystem;
